import type { ConsentMethod } from "@/contracts";

import i18n from "@/i18n";

/**
 * How consent was obtained, in words an administrator would recognize.
 *
 * Worded as claims about a past event rather than as settings, because that
 * is what they are: the platform records what somebody says happened and can
 * verify none of it.
 */
export const CONSENT_METHOD_LABELS: Record<ConsentMethod, string> = {
  get WEBSITE() {
    return i18n.t("pages:consentMethod.WEBSITE");
  },
  get SMS() {
    return i18n.t("pages:consentMethod.SMS");
  },
  get PHONE() {
    return i18n.t("pages:consentMethod.PHONE");
  },
  get IN_PERSON() {
    return i18n.t("pages:consentMethod.IN_PERSON");
  },
  get PAPER() {
    return i18n.t("pages:consentMethod.PAPER");
  },
};

/**
 * Numbers are shown exactly as stored, in E.164.
 *
 * There was a version of this that grouped the digits for readability, and it
 * grouped them wrongly: where the country code ends and the subscriber number
 * begins differs by country, so any single pattern misreads most of the world.
 * An unambiguous number nobody has to second-guess beats a prettier one that
 * is sometimes a lie, and this is the same string the providers are given.
 */
